'use client'

import { useEffect } from 'react'
import { getBugsnag } from '@/utils/bugsnag.client'

type SegmentErrorBoundaryProps = {
  readonly error: Error & { digest?: string }
  readonly reset: () => void
}

export default function SegmentErrorBoundary({
  error,
  reset,
}: SegmentErrorBoundaryProps) {
  useEffect(() => {
    const bugsnag = getBugsnag()
    if (bugsnag) {
      bugsnag.notify(error, (event) => {
        event.addMetadata('next', {
          digest: error.digest,
          pathname:
            typeof window === 'undefined'
              ? undefined
              : window.location.pathname,
          search:
            typeof window === 'undefined' ? undefined : window.location.search,
        })
      })
    }
  }, [error])

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-zinc-100">
      <div className="mb-4 text-3xl font-semibold text-slate-500">Skop</div>
      <h2 className="text-lg text-slate-500">
        Une erreur interne s&apos;est produite
      </h2>
      <span className="text-slate-300">
        Le support en a été informé, nous travaillons à sa résolution
      </span>
      {error instanceof Error &&
        !!error.message &&
        process.env.NODE_ENV === 'development' && (
          <pre className="mt-2 max-w-lg rounded-md bg-neutral-200 p-2 text-xs text-slate-500">
            {error.message}
          </pre>
        )}
      <div className="mt-4 flex items-center space-x-4">
        <button
          onClick={reset}
          className="text-slate-200 underline underline-offset-2 hover:text-slate-100"
        >
          Réessayer
        </button>
        <a
          href="https://support.skop.app"
          className="text-slate-200 underline underline-offset-2 hover:text-slate-100"
        >
          Contacter le support
        </a>
      </div>
    </div>
  )
}
